/*eslint-disable */

import { bus } from '@/main';
import forwardMsgPopup from "@/components/private/workspace/forward-msg-popup/index.vue";
import { mapGetters } from 'vuex';

export default {
  name: 'message-search-popup',
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  },
  components: {
    forwardMsgPopup
  },
  props: ['messageSearchForChatInfo', 'roomSocketUrl'],
  data () {
    return {
      selfUserId:'',
      selfUserInfo:null,
      chatInfo:null,
      search_term:'',
      searchMessageData:null,
      searchMessageResults:[],
      searchMessageActionState:false,
      msgSearchApiLoader:false,
      replyOnMessageBoxState:false,
      replyOnMessageData:null,
      sendMessageTxt:'',
      replyMsgForSeletedId:'',
      forwardMsgInfo:[],
      forwardMsgPopup:false
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getselfUserInfoFun() {
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data;
      return;
    },
  },
  mounted () {
    document.body.classList.add('body_right_scroll_remove');
    this.getselfUserInfoFun;
    this.selfUserId = localStorage.getItem('LoginedUserID');
    this.chatInfo = this.messageSearchForChatInfo;
    bus.$on('forwardMsgPopupBus', (data) => {
      this.forwardMsgPopup = data;
    })
  },
  methods: {
    isImageFile(filePath) {
      const imageExtensions = ['png', 'jpeg', 'jpg', 'svg', 'gif', 'webp'];
      const fileExtension = filePath.split('.').pop().toLowerCase();
      let extension = fileExtension.substring(0, fileExtension.lastIndexOf("?"));
      return imageExtensions.includes(extension);
    },
    getFileName(filePath) {
      return filePath.split('/').pop().split('?')[0];
    },
    newline(){},
    /*
     * This Will Checking Chat Message Position 
     */
    CheckingMessageSentReceivedPositionForRoomMethod(ChatData) {
      if(!ChatData) return;
      if (ChatData.sender.user_id == this.selfUserId) {
        return 'sent_message_of_search';
      } else {
        return 'received_message_of_search';
      }
    },
    /*
    * This Will Message Search For Method
    */
    messageSearchFromRoomMethod(){
      if(this.search_term.length >= 3){
        this.searchMessageActionState = true;
        this.msgSearchApiLoader = true;
        let payload = {
          search_term:this.search_term,
          id:this.chatInfo.chat_room
        }
        this.$store.dispatch('getMessageSearchAction', payload).then((res) => {
          if(res.status == '200'){
            setTimeout(() => { 
              this.searchMessageData = res.data.data;
              this.searchMessageResults = this.searchMessageData.results;
              this.msgSearchApiLoader = false;
            })
          }
        }).catch((err) => {
          this.msgSearchApiLoader = false;
        })
      }else{
        this.searchMessageData = null;
        this.searchMessageResults = [];
        this.searchMessageActionState = false;
        this.msgSearchApiLoader = false;
      }
    },
    clearSearchTermAction(){
      this.search_term = '';
      this.searchMessageActionState = false;
      this.searchMessageData = null;
      this.searchMessageResults = [];
    },
    searchMessagePopupCloseMethod(){
      bus.$emit('messageSearchPopupStateBus', false);
      document.body.classList.remove('body_right_scroll_remove');
    },
    replyOnMessageViewOpenMethod(msgInfo){
      this.replyMsgForSeletedId = msgInfo.id;
      this.replyOnMessageData = msgInfo;
      this.replyOnMessageBoxState = true;
      setTimeout(() => {
        // Set the scrollTop property of the element to its scroll height
        const element = document.getElementById('message_search_id');
        const tHeight = element.scrollHeight + parseInt('155');
        element.scrollTop = tHeight;
      }, 200);
    },
    replyOnMessageViewClosedMethod(){
      this.replyOnMessageData = null;
      this.replyOnMessageBoxState = false;
      this.replyMsgForSeletedId = '';
    },
    sendMessageOnSearchInGRoomMethod(){
      if(this.sendMessageTxt == '') return;
      const payload = {
        chatRoomId: this.chatInfo.id,
      };
      if(this.replyMsgForSeletedId){
        this.roomSocketUrl.send(JSON.stringify({
           type: 'chat_message',
            message: {
              content: this.sendMessageTxt,
              reply_to: this.replyMsgForSeletedId,
            }
        }));
      }
      let socketTimeout = setTimeout(function () {
        bus.$emit('newChatMessage', payload);
        clearTimeout(socketTimeout);
      }, 800);
      this.sendMessageTxt = '';
      this.searchMessagePopupCloseMethod();
    },
    forwardMsgToUserMethod(data) {
      this.forwardMsgPopup = true;
      this.forwardMsgInfo.push(data);
    },
  },
  watch:{
    getselfUserInfoFun() {
      return this.$store.getters.acUserDetailsStateGetters;
    },
  }
}